document.addEventListener('DOMContentLoaded', () => {
  // GUARANTEE POPUP BLOCK
  const guarantee_popup_block_open_button = document.getElementById('block-guarantee-popup-open-button');
  const guarantee_popup_block_wrapper = document.getElementById('block-guarantee-popup-wrapper');
  const guarantee_popup_block_close_button = document.getElementById('block-guarantee-popup-close-button');

  if (guarantee_popup_block_open_button && guarantee_popup_block_wrapper) {
    guarantee_popup_block_open_button.addEventListener('click', () => {
      guarantee_popup_block_wrapper.classList.remove('hidden');
    });
  }

  if (guarantee_popup_block_close_button && guarantee_popup_block_wrapper) {
    guarantee_popup_block_close_button.addEventListener('click', () => {
      guarantee_popup_block_wrapper.classList.add('hidden');
    });
  }

  (function () {
    const el = document.querySelector('.color-list-slider-wrapper');
    if (!el) return;

    const bar = document.querySelector('.color-list-scrollbar');
    const track = bar.querySelector('.track');
    const thumb = bar.querySelector('.thumb');

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let rafId = 0;
    let momentumRunning = false;

    const stopMomentum = () => {
      momentumRunning = false;
      cancelAnimationFrame(rafId);
    };

    const momentum = () => {
      momentumRunning = true;
      
      if (Math.abs(velocity) < 0.01) {
        momentumRunning = false;
        return;
      }
      el.scrollLeft -= velocity * 12;
      velocity *= 0.95;
      
      updateThumb();
      rafId = requestAnimationFrame(momentum);
    };

    el.addEventListener('dragstart', (e) => e.preventDefault());

    el.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add('grabbing');

      bar.classList.add('active');

      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      velocity = 0;
      lastX = e.clientX;
      lastTime = Date.now();
      stopMomentum();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.clientX - startX;
      el.scrollLeft = startScrollLeft - dx;

      const now = Date.now();
      const dt = now - lastTime;
      if (dt > 0) velocity = (e.clientX - lastX) / dt;
      lastX = e.clientX;
      lastTime = now;

      updateThumb();
    }, { passive: false });

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('grabbing');

      setTimeout(() => bar.classList.remove('active'), 120);

      if (Math.abs(velocity) > 0.08) momentum();
    };

    window.addEventListener('mouseup', endDrag);
    el.addEventListener('mouseleave', endDrag);

    function updateThumb() {
      const cw = el.clientWidth;
      const sw = el.scrollWidth;
      const sl = el.scrollLeft;

      if (sw <= cw) {
        thumb.style.width = '0px';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      const trackW = track.clientWidth;
      const minThumb = 40;
      const thumbW = Math.max((cw / sw) * trackW, minThumb);
      const maxLeft = trackW - thumbW;
      const left = (sl / (sw - cw)) * maxLeft;

      thumb.style.width = thumbW + 'px';
      thumb.style.transform = `translateX(${left}px)`;
    }

    function syncBarWidth() {
      //const rect = el.getBoundingClientRect();
      //bar.style.width = rect.width + 'px';
      updateThumb();
    }

    el.addEventListener('scroll', () => {
      updateThumb();
    }, { passive: true });

    window.addEventListener('resize', syncBarWidth);

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => syncBarWidth());
      ro.observe(el);
      ro.observe(track);
    } else {
      setTimeout(syncBarWidth, 60);
    }

    syncBarWidth();
    setTimeout(syncBarWidth, 250);
  })();

  // VARIABLES
  const sectionWrapper = document.getElementById('section-wrapper');
  const addToCartText = sectionWrapper.dataset.addToCartText;
  const chooseColorText = sectionWrapper.dataset.chooseColorText; 
  const placeholder_color_name = sectionWrapper.dataset.placeholderColorName;
  
  // KEENSLIDER
  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }
      
      function addActive(idx) {
        slider.slides[idx].classList.add("active")
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          addActive(main.track.absToRel(next))
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
        })
      })
    };
  }

  const product_slider_slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
  product_slider_slides.forEach((slide) => {
    slide.classList.remove("hidden", "mr-[10px]");
  });

  const product_large_slider = new KeenSlider(
    "#product-keen-large-slider", 
    {
      loop: false,
      slides: {
        spacing: 8,
        perView: 1.1,
      },
    }
  );

  const product_thumbnails_slider = new KeenSlider(
    "#product-keen-thumbnail-slider",
    {
        loop: false,
        slides: {
          spacing: 10,
          perView: 6,
        },
        vertical: false,
    },
    [ThumbnailPlugin(product_large_slider)]
  );

  // CUSTOM STICKY ATC BUTTON
  const stickyButtonWrapper = document.querySelector('.byteex-stycky-atc-button-wrapper');
  const stickyButton = document.getElementById('byteex-stycky-atc-button');
  const stickyButtonText = document.getElementById('sticky_atc_button_text');
  const nail_picker = document.getElementById('nail_picker');  
  const productForm = document.querySelector('form[action$="/cart/add"]');
  const submitButton = productForm?.querySelector('button');

  if (stickyButtonWrapper && stickyButtonText && productForm && submitButton) {
    const scrollToElement = (el, offset = 0) => {
      const targetY = el.getBoundingClientRect().top + window.scrollY - offset;
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      } else {
        window.scrollTo(0, targetY);
      }
    };

    if (submitButton.getAttribute('type') === 'button') {
      stickyButtonText.innerText = chooseColorText;
    } else {
      stickyButtonText.innerText = addToCartText;
    }

    stickyButtonWrapper.addEventListener('click', () => {
      scrollToElement(nail_picker, 200);
    });

    const checkButtonPosition = () => {
      const currentSubmitButton = productForm.querySelector('button');
      const buttonRect = currentSubmitButton.getBoundingClientRect();
      if (buttonRect.bottom <= 70) {
        stickyButtonWrapper.style.transform = 'translateY(0px)';
      } else {
        stickyButtonWrapper.style.transform = 'translateY(140px)';
      }
    };

    window.addEventListener('scroll', checkButtonPosition);

    stickyButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const stickyLoader = document.getElementById('sticky_atc_button_loader');
      const loaderDisplayStyle = window.getComputedStyle(stickyLoader).display;
      const currentSubmitButton = productForm.querySelector('button');

      if (currentSubmitButton.getAttribute('type') === 'submit' && loaderDisplayStyle === 'none') {
        currentSubmitButton.click();
      } else {
        scrollToElement(nail_picker, 200);
      }
    });

    const buttonObserver = new MutationObserver(() => {
      const button = productForm.querySelector('button');
      if (!button) return;
      if (button.getAttribute('type') === 'submit') {
        stickyButtonText.innerText = addToCartText;
      } else {
        stickyButtonText.innerText = chooseColorText;
      }
    });

    buttonObserver.observe(submitButton, { attributes: true });
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById('two-video-block-button-1');
  const two_video_block_button_2 = document.getElementById('two-video-block-button-2');
  const two_video_block_video_1 = document.getElementById('two-video-block-video-1');
  const two_video_block_video_2 = document.getElementById('two-video-block-video-2');

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener('click', () => {
      two_video_block_video_1.classList.remove('hidden');
      two_video_block_video_2.classList.add('hidden');
      two_video_block_button_1.style.borderBottom = 'thin solid #211912';
      two_video_block_button_2.style.borderBottom = 'none';
    });

    two_video_block_button_2.addEventListener('click', () => {
      two_video_block_video_1.classList.add('hidden');
      two_video_block_video_2.classList.remove('hidden');
      two_video_block_button_1.style.borderBottom = 'none';
      two_video_block_button_2.style.borderBottom = 'thin solid #211912';
    });
  }

  const selected_colors = document.querySelectorAll('.nail-picker-selected-color'); 
  const selected_colors_sticky_atc = document.querySelectorAll('.byteex-stycky-atc-selected-color'); 
  const selected_colors_color_list = document.querySelectorAll('.color-list-selected-color'); 

  const hidden_overlay = document.getElementById('hidden-overlay');
  const color_items = document.querySelectorAll('.nail-picker-color');
  if (color_items.length) {
    color_items[color_items.length - 1].classList.add('nail-picker-color-last');
  }

  const remove_selected_colors = document.querySelectorAll('.remove-selected-color');

  const product_form = document.querySelector('.main-product-form');
  const main_atc_button = document.getElementById('byteex-submit-button');

  const atc_button_text = document.getElementById('atc-button-text');
  const choose_color_button_text = document.getElementById('choose-color-button-text');

  const variant_picker_data = document.getElementById('variant-picker-data');
  let colors_number = variant_picker_data.dataset.maxWrapsNumber;

  const variant_number_pre_selected = variant_picker_data.dataset.variantNumberPreSelected;
  const variant_number_pre_selected_number = parseInt(variant_number_pre_selected) - 1;

  const giftItems = document.querySelectorAll(".gift-item");

  const priceBlocks = document.querySelectorAll(".price-block");
  const priceAtc = document.querySelector(".price-atc");
  const nail_picker_title_wraps_number = document.getElementById('nail-picker-title-wraps-number'); 

  // VARIANT PICKER
  const variantPickerItems = document.querySelectorAll(".variant-picker-item");
  const variantMessage = document.getElementById('variant-message');

  variantPickerItems.forEach((variant, idx, arr) => {
    variant.addEventListener("click", (e) => {
      const current_item = e.currentTarget;
      const id = current_item.dataset.id;
      const giftCount = current_item.dataset.giftCount;
      const wrapsNumber = current_item.dataset.wrapsNumber;
      const message = current_item.dataset.message;

      if (variantMessage) {
        variantMessage.textContent = message;
      }

      if (nail_picker_title_wraps_number) {
        nail_picker_title_wraps_number.textContent = wrapsNumber;
      }

      priceBlocks.forEach((block, index) => {
        block.style.display = "none";

        if (idx === index) {
          block.style.display = "block";

          const priceBlockData = block.querySelector(".price-block-data");
          const price = priceBlockData.dataset.price;
          const comparePrice = priceBlockData.dataset.comparePrice;

          if (priceAtc.children[0]) {
            priceAtc.children[0].innerHTML = price;
          }

          if (priceAtc.children[1]) {
            priceAtc.children[1].innerHTML = comparePrice;
          }
        }
      });

      colors_number = parseInt(wrapsNumber) || 0;
      
      giftItems.forEach((item, idx) => {
        const image = item.querySelector("img");
        const svg = item.querySelector(".lock-icon");

        image.style.display = "block";
        svg.style.display = "none";

        if (idx > giftCount - 1) {
          image.style.display = "none";
          svg.style.display = "block";
        }
      });

      selected_colors.forEach((color, idx) => {
        const image = color.querySelector("img");
        const plus_icon = color.querySelector("span");
        const lock_icon = color.querySelector(".lock-icon");
        const remove_button = color.querySelector(".remove-selected-color");
        const color_name = color.querySelector("p");
        const isSelected = color.dataset.selected;
        const image_wrapper = color.firstElementChild;

        if (idx > 0) {
          const free_label = color.querySelector('.nail-picker-selected-color-free-label');

          switch (colors_number) {
            case 8:
              if (idx > 4) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
            case 7:
              if (idx > 3) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
            case 6:
              if (idx === 4 || idx === 5) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
            case 5:
              if (idx === 3 || idx === 4) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
            case 4:
              if (idx === 3) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
            case 3:
              if (idx === 2) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
            case 2:
              if (idx === 1) {
                free_label.style.display = 'block';
              } else {
                free_label.style.display = 'none';
              }
              break;
          }
        }        

        if (!isSelected || isSelected === "false") {
          image.style.opacity = "1";
          plus_icon.style.display = "block";
          lock_icon.style.display = "none";

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            const img = current_selected_colors_sticky_atc.querySelector('img');
            if (img) {
              img.style.opacity = "1";
            }

            const span = current_selected_colors_sticky_atc.querySelector('span');
            if (span) {
              span.style.display = "block";
            }

            const lock_icon = current_selected_colors_sticky_atc.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "none";
            }
          }

          const current_selected_colors_color_list = selected_colors_color_list[idx];
          if (current_selected_colors_color_list) {
            const img = current_selected_colors_color_list.querySelector('img');
            if (img) {
              img.style.opacity = "1";
            }

            const span = current_selected_colors_color_list.querySelector('span');
            if (span) {
              span.style.display = "block";
            }

            const lock_icon = current_selected_colors_color_list.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "none";
            }
          }
        }

        if (idx > colors_number - 1) {
          color.removeAttribute("data-selected");
          color.removeAttribute("data-id");

          image.removeAttribute('src');
          image.classList.add('hidden');
          color_name.textContent = `${placeholder_color_name} ${idx + 1}`;

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            const img = current_selected_colors_sticky_atc.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const span = current_selected_colors_sticky_atc.querySelector('span');
            if (span) {
              span.style.display = "none";
            }

            const lock_icon = current_selected_colors_sticky_atc.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "block";
            }

            current_selected_colors_sticky_atc.style.backgroundColor = "#FAF7F5";
            current_selected_colors_sticky_atc.style.borderColor = "#2119124D";
          }

          const current_selected_colors_color_list = selected_colors_color_list[idx];
          if (current_selected_colors_color_list) {
            const img = current_selected_colors_color_list.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const span = current_selected_colors_color_list.querySelector('span');
            if (span) {
              span.style.display = "none";
            }

            const lock_icon = current_selected_colors_color_list.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "block";
            }

            current_selected_colors_color_list.style.backgroundColor = "#FAF7F5";
            current_selected_colors_color_list.style.borderColor = "#2119124D";
          }

          plus_icon.style.display = "none";
          lock_icon.style.display = "block";
          remove_button.style.display = "none";

          image_wrapper.style.backgroundColor = "#FAF7F5";
          image_wrapper.style.borderColor = "#2119124D";
        } else {
          image_wrapper.style.backgroundColor = "#ffffff";
          image_wrapper.style.borderColor = "#211912B2";

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            current_selected_colors_sticky_atc.style.backgroundColor = "#ffffff";
            current_selected_colors_sticky_atc.style.borderColor = "#211912B2";
          }

          const current_selected_colors_color_list = selected_colors_color_list[idx];
          if (current_selected_colors_color_list) {
            current_selected_colors_color_list.style.backgroundColor = "#ffffff";
            current_selected_colors_color_list.style.borderColor = "#211912B2";
          }
        }
      });

      const count = getSelectedCount();

      if (count === colors_number) {      
        color_items.forEach(color_item => {
          const add_color_item_button = color_item.querySelector('.add-color-item-button');
          const selection_completed_button = color_item.querySelector('.selection-completed-button');
          const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 
  
          add_color_item_button.classList.add('hidden');
          selection_completed_button.classList.remove('hidden');
          quantity_color_item_wrapper.classList.add('hidden');

          const color_id = color_item.dataset.id;
          const color_count = checkSelectedColor(color_id);
          const color_item_count = color_item.querySelector('.color-item-count');
  
          if (color_count > 0) {
            if (color_item_count) {
              color_item_count.textContent = color_count;
            }
          } else {
            if (color_item_count) {
              color_item_count.textContent = 0;
            }
  
            const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');  
            current_color_img.classList.remove('selected-color-item');
          }
        });
      } else {
        color_items.forEach(color_item => {
          const color_id = color_item.dataset.id;
          const color_count = checkSelectedColor(color_id);
          const color_item_count = color_item.querySelector('.color-item-count');

          const selection_completed_button = color_item.querySelector('.selection-completed-button');
          selection_completed_button.classList.add('hidden');
  
          if (color_count > 0) {        
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
            quantity_color_item_wrapper.classList.remove('hidden');

            if (color_item_count) {
              color_item_count.textContent = color_count;
            }
          } else {
            const add_color_item_button = color_item.querySelector('.add-color-item-button');
            add_color_item_button.classList.remove('hidden');

            if (color_item_count) {
              color_item_count.textContent = 0;
            }
  
            //const current_color_img = color_item.querySelector('img');
            const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');  
            current_color_img.classList.remove('selected-color-item');
  
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 
            if (quantity_color_item_wrapper) {
              quantity_color_item_wrapper.classList.add('hidden');
            }
          }
        });
      }

      arr.forEach(item => {
        item.style.backgroundColor = "#ffffff";
      });

      current_item.style.backgroundColor = "#F2EBE3";

      const productId = document.getElementById("product-id");
      productId.value = id;
      product_form.dataset.variantId = id;

      // Update properties      
      const current_properties_block = document.getElementById('nail-picker-properties-block');
      if (current_properties_block) {
        current_properties_block.remove();
      }

      if (count === colors_number) {
        atc_button_text.style.display = 'flex';
        choose_color_button_text.style.display = 'none';
        main_atc_button.type = 'submit';

        const properties_block = document.createElement('div');
        properties_block.setAttribute('id', 'nail-picker-properties-block');
        
        selected_colors.forEach((color, i) => {
          const isCurrentSelected = color.dataset.selected;

          if (isCurrentSelected) {
            const id = color.dataset.id;

            const text_tag = color.querySelector('p');
            const title = text_tag.textContent;

            const img_tag = color.querySelector('img');
            const image = img_tag.dataset.imageLineItem;

            const hiddenField1 = document.createElement('input');
            hiddenField1.setAttribute('type', "hidden");
            hiddenField1.setAttribute('class', `class${i + 1}`);
            hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
            hiddenField1.setAttribute('value', image);
            properties_block.appendChild(hiddenField1);        

            const hiddenField2 = document.createElement('input');
            hiddenField2.setAttribute('type', "hidden");
            hiddenField2.setAttribute('class', `class${i + 1}`);
            hiddenField2.setAttribute('name', `properties[Gel ${i + 1}]`);
            hiddenField2.setAttribute('value', title);
            properties_block.appendChild(hiddenField2);

            const hiddenField3 = document.createElement('input');
            hiddenField3.setAttribute('type', "hidden");
            hiddenField3.setAttribute('class', `class${i + 1}`);
            hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
            hiddenField3.setAttribute('value', id);
            properties_block.appendChild(hiddenField3);
          }
        });

        product_form.appendChild(properties_block);
      } else {
        atc_button_text.style.display = 'none';
        choose_color_button_text.style.display = 'flex';
        main_atc_button.type = 'button';
      }
    });
  });

  variantPickerItems[variant_number_pre_selected_number].click();

  // *** NAIL PICKER *** //

  const nail_picker_color_open_popup = document.querySelectorAll('.nail-picker-color-open-popup');
  const nail_picker_color_close_popup = document.querySelectorAll('.nail-picker-color-close-popup');
  const nail_picker_color_popup_add_buttons = document.querySelectorAll('.nail-picker-color-popup-add-button');
  const remove_selected_color_items = document.querySelectorAll('.remove-selected-color-item');

  // OPEN COLOR LIST POPUP
  const nail_picker_color_list_wrapper = document.getElementById('nail-picker-color-list-wrapper');
  
  main_atc_button.addEventListener('click', (event) => {
    const current_target = event.currentTarget;
    const button_type = current_target.type;

    console.log(button_type);

    if (button_type === 'button') {
      hidden_overlay.classList.remove('hidden');
      nail_picker_color_list_wrapper.classList.remove('hidden');

      document.body.style.overflow = 'hidden';
      /*setTimeout(() => {
        document.addEventListener('click', outsideClickHandler);
      }, 100);*/
    }
  });

  selected_colors.forEach(color => {
    color.addEventListener('click', (event) => {
      hidden_overlay.classList.remove('hidden');
      nail_picker_color_list_wrapper.classList.remove('hidden');

      document.body.style.overflow = 'hidden';
      /*setTimeout(() => {
        document.addEventListener('click', outsideClickHandler);
      }, 100);*/
    });
  });

  // CLOSE COLOR LIST POPUP
  const nail_picker_color_list_close_popup = document.querySelectorAll('.nail-picker-color-list-close-popup');
  nail_picker_color_list_close_popup.forEach(item => {
    item.addEventListener('click', (event) => {
      hidden_overlay.classList.add('hidden');
      nail_picker_color_list_wrapper.classList.add('hidden');

      document.body.style.overflow = 'auto';
      //document.removeEventListener('click', outsideClickHandler);
    });
  });

  /*function outsideClickHandler(event) {
    if (
      nail_picker_color_list_wrapper &&
      !nail_picker_color_list_wrapper.classList.contains('hidden')
    ) {
      if (!nail_picker_color_list_wrapper.contains(event.target)) {
        nail_picker_color_list_wrapper.classList.add('hidden');
        hidden_overlay.classList.add('hidden');
        document.body.style.overflow = 'auto';
  
        document.removeEventListener('click', outsideClickHandler);
      }
    }
  }*/

  // open guarantee popup
  const guarantee_popup_open_button = document.getElementById('guarantee-popup-open-button');
  const guarantee_popup_content = document.getElementById('guarantee-popup-content');
  const guarantee_popup_close_buttons = document.querySelectorAll('.guarantee-popup-close-button');

  if (guarantee_popup_open_button && guarantee_popup_content) {
    guarantee_popup_open_button.addEventListener('click', () => {
      guarantee_popup_content.classList.remove('hidden');
      nail_picker_color_list_wrapper.style.overflowY = 'hidden';
    });
  }

  // close guarantee popup
  if (guarantee_popup_close_buttons && guarantee_popup_content) { 
    guarantee_popup_close_buttons.forEach(item => {
      item.addEventListener('click', () => {
        guarantee_popup_content.classList.add('hidden');
        nail_picker_color_list_wrapper.style.overflowY = 'auto';
      });
    });
  }

  // --- COLOR POPUP --- //
  
  // slider init
  let slider = null;
  function sliderInit(elementId) {
    function sliderNavigation(slider) {
      let controlsWrapper, dots, arrowLeft, arrowRight;
    
      function removeElement(el) {
        el?.parentNode?.removeChild(el);
      }
    
      function createDiv(className) {
        const div = document.createElement("div");
        className.split(" ").forEach(name => div.classList.add(name));
        return div;
      }
    
      function controlsMarkup(remove) {
        if (remove) {
          removeElement(controlsWrapper);
          return;
        }
    
        controlsWrapper = createDiv("product-image-keen-slider-navigation-controls");
    
        arrowLeft = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--left");
        arrowRight = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--right");
    
        arrowLeft.innerHTML = " "; 
        arrowRight.innerHTML = " ";
    
        arrowLeft.addEventListener("click", () => slider.prev());
        arrowRight.addEventListener("click", () => slider.next());
    
        controlsWrapper.appendChild(arrowLeft);
        controlsWrapper.appendChild(arrowRight);
    
        dots = createDiv("product-image-keen-slider-dots");
        const totalSlides = slider.track.details.slides.length;
    
        for (let i = 0; i < totalSlides; i++) {
          const dot = createDiv("product-image-keen-slider-dot");
          dot.addEventListener("click", () => slider.moveToIdx(i));
          dots.appendChild(dot);
        }
    
        controlsWrapper.appendChild(dots);
        slider.container.parentNode.appendChild(controlsWrapper);
      }
    
      function updateClasses() {
        const rel = slider.track.details.rel;
    
        if (dots) {
          Array.from(dots.children).forEach((dot, idx) => {
            dot.classList.toggle("product-image-keen-slider-dot--active", idx === rel);
          });
        }
    
        if (arrowLeft && arrowRight) {
          const maxIdx = slider.track.details.slides.length - 1;
          arrowLeft.classList.toggle("disabled", rel === 0);
          arrowRight.classList.toggle("disabled", rel === maxIdx);
        }
      }
    
      slider.on("created", () => {
        controlsMarkup();
        updateClasses();
      });
    
      slider.on("slideChanged", updateClasses);
      slider.on("destroyed", () => controlsMarkup(true));
    }
    
    slider = new KeenSlider(
      elementId,
      {
        loop: false,
        slides: { perView: 1, spacing: 16 }
      },
      [sliderNavigation]
    );
  };

  // open nail picker color popup
  nail_picker_color_open_popup.forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const data_popup_id = current_color.dataset.popupId;

      const color_popup = document.getElementById(data_popup_id);
      if (color_popup) {
        color_popup.classList.remove('hidden');
        nail_picker_color_list_wrapper.style.overflowY = 'hidden';

        const slider_container = color_popup.querySelector('.keen-slider');

        if (slider_container) {
          sliderInit(slider_container);
        }
      }      
    });
  });

  // close nail picker color popup
  nail_picker_color_close_popup.forEach(item => { 
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;      

      if (slider) {
        slider.destroy();
        slider = null;
      }

      const choose_color_popup = document.getElementById(data_id);
      choose_color_popup.classList.add('hidden');
      nail_picker_color_list_wrapper.style.overflowY = 'auto';
    });
  });

  // --- ADD COLORS TO PICKER --- //

  // get selected count
  function getSelectedCount() {
    let count = 0;
    selected_colors.forEach(color => {
      const isSelected = color.dataset.selected;
      if (isSelected) {
        count++;
      }
    });
    return count;
  }

  // add color function
  function addColor(id, image, image_line_item, title) {
    let loop_count = -1;
    for (const color of selected_colors) {
      loop_count++;
      const isSelected = color.dataset.selected;

      if (!isSelected) {
        const img = color.querySelector('img');
        img.setAttribute('src', image);
        img.classList.remove('hidden');
        img.dataset.imageLineItem = image_line_item;

        const current_selected_colors_sticky_atc = selected_colors_sticky_atc[loop_count];
        if (current_selected_colors_sticky_atc) {
          const img = current_selected_colors_sticky_atc.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const span = current_selected_colors_sticky_atc.querySelector('span');
          if (span) {
            span.style.display = "none";
          }
        }

        const current_selected_colors_color_list = selected_colors_color_list[loop_count];
        if (current_selected_colors_color_list) {
          const img = current_selected_colors_color_list.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const span = current_selected_colors_color_list.querySelector('span');
          if (span) {
            span.style.display = "none";
          }
        }

        const color_name = color.querySelector('p');
        color_name.textContent = title;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'none';

        const remove_button = color.querySelector('.remove-selected-color');
        remove_button.style.display = 'block';
        
        color.dataset.selected = true;
        color.dataset.id = id;
        break;
      }
    }

    const count = getSelectedCount();
    
    const current_properties_block = document.getElementById('nail-picker-properties-block');

    if (count === colors_number) {
      if (current_properties_block) {
        current_properties_block.remove();
      }

      color_items.forEach(color_item => {
        const add_color_item_button = color_item.querySelector('.add-color-item-button');
        const selection_completed_button = color_item.querySelector('.selection-completed-button');
        const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 

        add_color_item_button.classList.add('hidden');
        selection_completed_button.classList.remove('hidden');
        quantity_color_item_wrapper.classList.add('hidden');
      });

      // close color list popup
      hidden_overlay.classList.add('hidden');
      nail_picker_color_list_wrapper.classList.add('hidden');
      document.body.style.overflow = 'auto';
      //document.removeEventListener('click', outsideClickHandler);

      atc_button_text.style.display = 'flex';
      choose_color_button_text.style.display = 'none';
      main_atc_button.type = 'submit';

      const properties_block = document.createElement('div');
      properties_block.setAttribute('id', 'nail-picker-properties-block');
      
      selected_colors.forEach((color, i) => {
        const is_selected = color.dataset.selected;

        if (is_selected === 'true') {
          const id = color.dataset.id;

          const text_tag = color.querySelector('p');
          const title = text_tag.textContent;

          const img_tag = color.querySelector('img');
          const image = img_tag.dataset.imageLineItem;

          const hiddenField1 = document.createElement('input');
          hiddenField1.setAttribute('type', "hidden");
          hiddenField1.setAttribute('class', `class${i + 1}`);
          hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
          hiddenField1.setAttribute('value', image);
          properties_block.appendChild(hiddenField1);        

          const hiddenField2 = document.createElement('input');
          hiddenField2.setAttribute('type', "hidden");
          hiddenField2.setAttribute('class', `class${i + 1}`);
          hiddenField2.setAttribute('name', `properties[Gel ${i + 1}]`);
          hiddenField2.setAttribute('value', title);
          properties_block.appendChild(hiddenField2);

          const hiddenField3 = document.createElement('input');
          hiddenField3.setAttribute('type', "hidden");
          hiddenField3.setAttribute('class', `class${i + 1}`);
          hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
          hiddenField3.setAttribute('value', id);
          properties_block.appendChild(hiddenField3);
        }
      });

      product_form.appendChild(properties_block);
    }
  }

  // add color to picker from color list
  color_items.forEach(color_item => {
    const add_color_item_button = color_item.querySelector('.add-color-item-button');

    if (add_color_item_button) {      
      add_color_item_button.addEventListener('click', () => {
        const current_color = color_item;
        const data_id = current_color.dataset.id;
        const data_title = current_color.dataset.title;
        const data_image = current_color.dataset.image;
        const data_image_line_item = current_color.dataset.imageLineItem;

        const current_selected_colors = getSelectedCount();

        if (current_selected_colors < colors_number) {
          const current_color_img = current_color.querySelector('.nail-picker-color-image-wrapper');

          current_color_img.classList.add('selected-color-item');
          current_color.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');

          addColor(data_id, data_image, data_image_line_item, data_title);
          
          const color_count = checkSelectedColor(data_id);
          const color_item_count = current_color.querySelector('.color-item-count');

          if (color_item_count) {
            color_item_count.textContent = color_count;
          }
        }
      });
    }

    const add_color_item_button_plus = color_item.querySelector('.color-item-count-plus');

    if (add_color_item_button_plus) {
      add_color_item_button_plus.addEventListener('click', () => {
        const current_color = color_item;
        const data_id = current_color.dataset.id;
        const data_title = current_color.dataset.title;
        const data_image = current_color.dataset.image;
        const data_image_line_item = current_color.dataset.imageLineItem;

        const current_selected_colors = getSelectedCount();

        if (current_selected_colors < colors_number) {
          addColor(data_id, data_image, data_image_line_item, data_title);
          
          const color_count = checkSelectedColor(data_id);
          const color_item_count = current_color.querySelector('.color-item-count');

          if (color_item_count) {
            color_item_count.textContent = color_count;
          }
        }
      });
    }
  });

  // add color to picker from color popup
  nail_picker_color_popup_add_buttons.forEach(item => {
    item.addEventListener('click', (event) => {
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;
      const data_title = current_color.dataset.title;
      const data_image = current_color.dataset.image;
      const data_image_line_item = current_color.dataset.imageLineItem;
      const data_popup_id = current_color.dataset.popupId;

      const current_selected_colors = getSelectedCount();

      if (current_selected_colors < colors_number) {
        addColor(data_id, data_image, data_image_line_item, data_title);

        const color_item = document.querySelector(`.nail-picker-color[data-id="${data_id}"]`);
        const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
        current_color_img.classList.add('selected-color-item');
        color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');

        const color_count = checkSelectedColor(data_id);
        const color_item_count = color_item.querySelector('.color-item-count');

        if (color_item_count) {
          color_item_count.textContent = color_count;
        }
      }

      //hidden_overlay.classList.add('hidden');
      
      const color_popup = document.getElementById(data_popup_id);
      color_popup.classList.add('hidden');

      if (slider) {
        slider.destroy();
        slider = null;
      }
    });
  });  

  // --- REMOVE COLORS FROM PICKER --- //
  
  // remove line item properties
  function removeProperties() {
    const current_properties_block = document.getElementById('nail-picker-properties-block');

    if (current_properties_block) {
      current_properties_block.remove();
      
      atc_button_text.style.display = 'none';
      choose_color_button_text.style.display = 'flex';
      main_atc_button.type = 'button';
    }
  }

  function checkSelectedColor(data_id) {
    let selected_count = 0;

    for (const color of selected_colors) {
      const color_id = color.dataset.id;

      if (color_id === data_id) {
        selected_count++;
      }
    }

    return selected_count;
  }

  // remove buttons on color items
  remove_selected_color_items.forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_item = event.currentTarget;
      const parent = current_item.closest('.nail-picker-color'); 
      const data_id = current_item.dataset.id;      

      let selected_count = 0;
      let selected_index;

      selected_colors.forEach((color, index) => {
        if (color.dataset.id === data_id) {
          selected_count++;
          selected_index = index;
        }
      });

      if (selected_count > 0) {
        const img = selected_colors[selected_index].querySelector('img');
        img.removeAttribute('src');
        img.classList.add('hidden');

        const current_selected_colors_sticky_atc = selected_colors_sticky_atc[selected_index];
        if (current_selected_colors_sticky_atc) {
          const img = current_selected_colors_sticky_atc.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const span = current_selected_colors_sticky_atc.querySelector('span');
          if (span) {
            span.style.display = "block";
          }
        }

        const current_selected_colors_color_list = selected_colors_color_list[selected_index];
        if (current_selected_colors_color_list) {
          const img = current_selected_colors_color_list.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const span = current_selected_colors_color_list.querySelector('span');
          if (span) {
            span.style.display = "block";
          }
        }

        const color_name = selected_colors[selected_index].querySelector('p');
        color_name.textContent = `${placeholder_color_name} ${selected_index + 1}`;

        const plus_icon = selected_colors[selected_index].querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = selected_colors[selected_index].querySelector('.remove-selected-color');
        remove_button.style.display = 'none';
        
        selected_colors[selected_index].removeAttribute('data-selected');
        selected_colors[selected_index].removeAttribute('data-id'); 
      }

      if (selected_count === 1) {
        const current_color_img = parent.querySelector('.nail-picker-color-image-wrapper');
        current_color_img.classList.remove('selected-color-item');
        parent.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
        parent.querySelector('.add-color-item-button').classList.remove('hidden');
      }

      const color_item_count = parent.querySelector('.color-item-count');
      const color_count = checkSelectedColor(data_id);
      if (color_count > 0) {        
        if (color_item_count) {
          color_item_count.textContent = color_count;
        }
      } else {
        if (color_item_count) {
          color_item_count.textContent = 0;
        }
      }   

      removeProperties();
    });
  });

  // remove buttons on selected colors
  remove_selected_colors.forEach((item, i) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const parent = current_color.parentElement;
      const item_number = i;

      const color_id = parent.dataset.id;
      const current_selected_color_count = checkSelectedColor(color_id);

      const count = getSelectedCount();
      if (count === colors_number) {      
        color_items.forEach(color_item => {
          const color_id = color_item.dataset.id;
          const color_count = checkSelectedColor(color_id);

          const selection_completed_button = color_item.querySelector('.selection-completed-button');
          selection_completed_button.classList.add('hidden');

          if (color_count > 0) {
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 
            quantity_color_item_wrapper.classList.remove('hidden');
          } else {
            const add_color_item_button = color_item.querySelector('.add-color-item-button');
            add_color_item_button.classList.remove('hidden');
          }
        });
      }

      const color_item = document.querySelector(`.nail-picker-color[data-id="${color_id}"]`);
      if (current_selected_color_count === 1) {
        if (color_item) {
          const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
          current_color_img.classList.remove('selected-color-item');
          color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
          color_item.querySelector('.add-color-item-button').classList.remove('hidden');
        }
      }

      const img = parent.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const current_selected_colors_sticky_atc = selected_colors_sticky_atc[item_number];
      if (current_selected_colors_sticky_atc) {
        const img = current_selected_colors_sticky_atc.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const span = current_selected_colors_sticky_atc.querySelector('span');
        if (span) {
          span.style.display = "block";
        }
      }

      const current_selected_colors_color_list = selected_colors_color_list[item_number];
      if (current_selected_colors_color_list) {
        const img = current_selected_colors_color_list.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const span = current_selected_colors_color_list.querySelector('span');
        if (span) {
          span.style.display = "block";
        }
      }

      const color_name = parent.querySelector('p');
      color_name.textContent = `${placeholder_color_name} ${item_number + 1}`;

      const plus_icon = parent.querySelector('span');
      plus_icon.style.display = 'block';

      const remove_button = parent.querySelector('.remove-selected-color');
      remove_button.style.display = 'none';
      
      parent.removeAttribute('data-selected');
      parent.removeAttribute('data-id');

      if (color_item) {
        const color_item_count = color_item.querySelector('.color-item-count');
        const color_count = checkSelectedColor(color_id);
        if (color_count > 0) {        
          if (color_item_count) {
            color_item_count.textContent = color_count;
          }
        } else {
          if (color_item_count) {
            color_item_count.textContent = 0;
          }
        }
      }

      removeProperties();
    });
  });

  // CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART - working in cart drawer
  window.clearNailPickerGelWraps = function() {
    selected_colors.forEach((item, i) => {
      const img = item.querySelector('img');
      img.removeAttribute('src');
      img.classList.add('hidden');
      img.style.opacity = '1';

      const color_name = item.querySelector('p');
      color_name.textContent = `${placeholder_color_name} ${i + 1}`;

      const plus_icon = item.querySelector('span');
      plus_icon.style.display = 'block';

      const remove_button = item.querySelector('.remove-selected-color');
      remove_button.style.display = 'none';

      const lock_icon = item.querySelector(".lock-icon");
      lock_icon.style.display = 'none';
      
      item.removeAttribute('data-selected');
      item.removeAttribute('data-id');
      
      const image_wrapper = item.firstElementChild;
      image_wrapper.style.backgroundColor = "#ffffff";
      image_wrapper.style.borderColor = "#211912B2";

      const free_label = item.querySelector('.nail-picker-selected-color-free-label');
      if (free_label) {
        if (i > 3) {
          free_label.style.display = 'block';
        } else {
          free_label.style.display = 'none';
        }
      }
    });

    selected_colors_sticky_atc.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const plus_icon = item.querySelector('span');
      if (plus_icon) {
        plus_icon.style.display = 'block';
      }

      const lock_icon = item.querySelector('.lock-icon');
      if (lock_icon) {
        lock_icon.style.display = 'none';
      }

      item.style.backgroundColor = "#ffffff";
      item.style.borderColor = "#211912B2";
    });

    selected_colors_color_list.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const span = item.querySelector('span');
      if (span) {
        span.style.display = "block";
      }
    });

    removeProperties();

    variantPickerItems[variant_number_pre_selected_number].click();

    color_items.forEach(color_item => {
      const color_item_count = color_item.querySelector('.color-item-count');
      if (color_item_count) {
        color_item_count.textContent = 0;
      }
      
      const selection_completed_button = color_item.querySelector('.selection-completed-button');
      selection_completed_button.classList.add('hidden');

      const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
      if (quantity_color_item_wrapper) {
        quantity_color_item_wrapper.classList.add('hidden');
      }

      const add_color_item_button = color_item.querySelector('.add-color-item-button');
      if (add_color_item_button) {
        add_color_item_button.classList.remove('hidden');
      }

      const current_color_img = color_item.querySelector('img');
      current_color_img.classList.remove('selected-color-item');
    });
  }
});
